import { render, staticRenderFns } from "./TimeSlot.vue?vue&type=template&id=a56e443a&scoped=true&"
import script from "./TimeSlot.vue?vue&type=script&lang=js&"
export * from "./TimeSlot.vue?vue&type=script&lang=js&"
import style0 from "./TimeSlot.vue?vue&type=style&index=0&id=a56e443a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a56e443a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VIcon,VRow,VSelect,VTextField})
